var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "14px",
    viewBox: "0 0 8 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-775.000000, -1368.000000)",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(736.000000, 1224.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.306,157.528 L44.0036,157.528 L44.0036,150.9992 L45.8032,150.9992 L46.0416,148.7496 L44.0036,148.7496 L44.0064,147.6232 C44.0064,147.0368 44.0624,146.722 44.904,146.722 L46.0288,146.722 L46.0288,144.472 L44.2288,144.472 C42.0668,144.472 41.306,145.5636 41.306,147.3988 L41.306,148.7496 L39.9584,148.7496 L39.9584,150.9996 L41.306,150.9996 L41.306,157.528 L41.306,157.528 Z",
    id: "Path"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default ForwardRef;